export default __webpack_public_path__ + "static/media/cleanproStep5.1821478c.png";